/**
 * Types inspired by https://github.com/Hotell/rex-tils
 * This lib is incompatible with redux-saga because it generates
 * freezed actions objects by using `Object.freeze()`. This conflicts
 * with saga dark magic because it mutates actions objects.
 */

/**
 * Action can exists only in 2 shapes. type only or type with payload
 */
export type Action<T extends string = string, P = void> = P extends void
  ? Readonly<{ type: T }>
  : Readonly<{ type: T; payload: P }>;

export function createAction<T extends string>(type: T): Action<T>;
export function createAction<T extends string, P>(
  type: T,
  payload: P
): Action<T, P>;

export function createAction<T extends string, P>(type: T, payload?: P) {
  return payload === undefined ? { type } : { type, payload };
}

export type ActionsUnion<A extends StringMap<AnyFunction>> = ReturnType<
  A[keyof A]
>;

export type ActionsOfType<
  ActionUnion,
  ActionType extends string
> = ActionUnion extends Action<ActionType> ? ActionUnion : never;

type AnyFunction = (...args: any[]) => any;
// tslint:disable
type StringMap<T> = { [key: string]: T };
